export default (texts, demoTexts) => {

  const pushTexts = function (texts) {

    const directTexts = texts[0];
    const titles = texts[1];
    const srcs = texts[2];

    for (let text in directTexts) {
      const currentTarget = document.querySelector('[data-text-' + text + ']');
      currentTarget.appendChild(document.createTextNode(directTexts[text]));
    }
    for (let title in titles) {
      const currentTarget = document.querySelector('[data-title-' + title + ']');
      currentTarget.setAttribute('title', titles[title]);
    }
    for (let src in srcs) {
      const currentTarget = document.querySelector('[data-src-' + src + ']');
      currentTarget.setAttribute('src', srcs[src]);
    }
  }

  const buildTitles = function (demoTexts) {

    for (let i = 0; i < demoTexts.length; i++) {
      const productName = demoTexts[i].productName;
      const productCode = demoTexts[i].productCode;
      const container = document.querySelector('.titles > [data-category=' + productCode + ']');
      const allSlides = demoTexts[i].slides;
      const slideCount = allSlides.length;

      for (let i = 0; i < allSlides.length; i++) {
        const title = allSlides[i].title;
        const code = allSlides[i].code;
        const titleSpan = document.createElement('span');
        const titleCount = document.createElement('small');
        const titleCountValue = i + 1;
        titleSpan.classList.add('title');
        titleSpan.setAttribute('data-title', code);
        titleSpan.appendChild(document.createTextNode(title));
        titleCount.appendChild(document.createTextNode(' (' + titleCountValue + '/' + slideCount + ')'));
        titleSpan.appendChild(titleCount);
        container.appendChild(titleSpan);
      }

      const firstTitle = document.querySelector('.titles > [data-category=' + productCode + '] .title:first-child');
      firstTitle.classList.add('current-title');
    }
  };

  const buildMenus = function (demoTexts) {

    for (let i = 0; i < demoTexts.length; i++) {
      const productName = demoTexts[i].productName;
      const productCode = demoTexts[i].productCode;
      const container = document.querySelector('.menu-items-wrapper[data-category=' + productCode + ']');
      const allSlides = demoTexts[i].slides;
      const slideCount = allSlides.length;

      for (let i = 0; i < allSlides.length; i++) {
        const title = allSlides[i].title;
        const code = allSlides[i].code;
        const itemLink = document.createElement('a');
        itemLink.classList.add('item');
        itemLink.setAttribute('data-target', code);
        itemLink.appendChild(document.createTextNode(title));
        container.appendChild(itemLink);
      }
    }
  };

  const buildProductNavigation = function (demoTexts) {

    const containerInModal = document.querySelector('.opening-modal .categories');
    const containerInApp = document.querySelector('.sidebar-header .categories');

    // buttons in opening modal
    for (let i = 0; i < demoTexts.length; i++) {
      const productName = demoTexts[i].productName;
      const productCode = demoTexts[i].productCode;
      const button = document.createElement('button');
      button.className = 'ui button basic';
      button.setAttribute('data-category-trigger', productCode);
      button.appendChild(document.createTextNode(productName));
      containerInModal.appendChild(button);
    }

    const select = document.createElement('select');
    select.className = 'ui dropdown';
    containerInApp.appendChild(select);

    // dropdown items (mobile)
    for (let i = 0; i < demoTexts.length; i++) {
      const productName = demoTexts[i].productName;
      const productCode = demoTexts[i].productCode;
      const option = document.createElement('option');
      option.setAttribute('value', productCode);
      option.appendChild(document.createTextNode(productName));
      select.appendChild(option);
    }
  }

  const buildSlides = function (demoTexts) {

    for (let i = 0; i < demoTexts.length; i++) {
      const productCode = demoTexts[i].productCode;
      const allSlides = demoTexts[i].slides;
      const container = document.querySelector('.slide-wrapper[data-category=' + productCode + ']');

      // create slides
      for (let slide = 0; slide < allSlides.length; slide++) {
        const code = demoTexts[i].slides[slide].code;
        const image = demoTexts[i].slides[slide].image;
        const infos = demoTexts[i].slides[slide].infos;
        const slideWrapper = document.createElement('div');
        const slideContentWrapper = document.createElement('div');
        const slideImage = document.createElement('img');
        slideWrapper.className = 'single-slide ' + code;
        slideWrapper.setAttribute('data-id', code);
        slideContentWrapper.classList.add('slide-content-wrapper');
        slideImage.setAttribute('src', './' + image + '');
        slideImage.setAttribute('alt', code);
        slideContentWrapper.appendChild(slideImage);
        slideWrapper.appendChild(slideContentWrapper);
        container.appendChild(slideWrapper);

        // create infos within slides
        for (let info = 0; info < infos.length; info++) {
          const buttonPosition = demoTexts[i].slides[slide].infos[info].buttonPosition;
          const buttonNumber = info + 1;
          const popupPosition = demoTexts[i].slides[slide].infos[info].popupPosition;
          const pointerPosition = demoTexts[i].slides[slide].infos[info].pointerPosition;
          const content = demoTexts[i].slides[slide].infos[info].content;
          const button = document.createElement('button');
          const pointer = document.createElement('div');
          const modals = demoTexts[i].slides[slide].infos[info].modals;
          button.className = 'circular ui button info-trigger';
          button.setAttribute('data-position', popupPosition[0] + ' ' + popupPosition[1]);
          button.setAttribute('data-html', content);
          button.style.left = buttonPosition[0] === 'auto' ? buttonPosition[0] : buttonPosition[0] + '%';
          button.style.top = buttonPosition[1] + '%';
          button.style.right = buttonPosition[2] === 'auto' ? buttonPosition[2] : buttonPosition[2] + '%';
          button.appendChild(document.createTextNode(buttonNumber));
          pointer.className = 'info-pointer';
          pointer.style.left = pointerPosition[0] + '%';
          pointer.style.top = pointerPosition[1] + '%';
          pointer.style.width = pointerPosition[2] + '%';
          pointer.style.height = pointerPosition[3] + '%';
          slideContentWrapper.appendChild(button);
          slideContentWrapper.appendChild(pointer);

          // create modals within slide infos
          if (modals.length >= 1) {
            for (let modal = 0; modal < modals.length; modal++) {
              const code = demoTexts[i].slides[slide].infos[info].modals[modal].code;
              const content = demoTexts[i].slides[slide].infos[info].modals[modal].content;
              button.classList.add('has-modal');
              button.setAttribute('data-target', code);
              const modalContainer = document.querySelector('body');
              const modalWrapper = document.createElement('div');
              const modalContent = document.createElement('div');
              const modalActions = document.createElement('div');
              const modalClose = document.createElement('div');
              modalWrapper.className = 'ui modal large';
              modalWrapper.setAttribute('data-id', code);
              modalContent.classList.add('content');
              modalContent.innerHTML = content;
              modalActions.classList.add('actions');
              modalClose.className = 'ui basic deny button';
              modalClose.appendChild(document.createTextNode('OK'));
              modalActions.appendChild(modalClose);
              modalWrapper.appendChild(modalContent);
              modalWrapper.appendChild(modalActions);
              modalContainer.appendChild(modalWrapper);
            }
          }
        }
      }

      const firstSlide = document.querySelector('.slide-wrapper[data-category=' + productCode + '] .single-slide:first-child');
      const lastSlide = document.querySelector('.slide-wrapper[data-category=' + productCode + '] .single-slide:last-child');
      firstSlide.classList.add('first');
      firstSlide.classList.add('visible');
      lastSlide.classList.add('last');
    }
  };

  pushTexts(texts);
  buildProductNavigation(demoTexts);
  buildTitles(demoTexts);
  buildMenus(demoTexts);
  buildSlides(demoTexts);
};